export const SAML_LOGIN_ACTION = '/saml/login/'

export const loginFieldClass =
  'grid gap-2 text-sm font-semibold text-slate-950 dark:text-slate-100'

export const loginInputClass =
  'min-h-11 w-full rounded-md border border-slate-200 bg-white px-3 py-2.5 text-base leading-snug text-slate-950 outline-none transition placeholder:text-slate-400 focus:border-violet-500 focus:ring-3 focus:ring-violet-500/15 dark:border-zinc-700 dark:bg-zinc-900 dark:text-slate-100 dark:placeholder:text-zinc-500'

export const loginButtonFocusClass =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-500'
